import PolarisDataSourceAPI from 'dashboard/api/polaris/dataSources';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PolarisDataSource',
  API: PolarisDataSourceAPI,
});
